import { render, staticRenderFns } from "./AssetDetails.vue?vue&type=template&id=f9767ec2&scoped=true"
import script from "./AssetDetails.vue?vue&type=script&lang=js"
export * from "./AssetDetails.vue?vue&type=script&lang=js"
import style0 from "./AssetDetails.vue?vue&type=style&index=0&id=f9767ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9767ec2",
  null
  
)

export default component.exports